<template>
  <FlexibleContent v-if="liveState" style="height: 100%;">
    <template v-slot:header>
      <div class="flex flex-f-c" style="margin: 1.25rem 0;">
        <span id="route-live-tag" class="text-tag bg-error">LIVE</span>
        <h2 style="width: 100%; margin: 0;" class="text-overflow-fade">{{ route.settings.name }}</h2>
        <AppButton @click="shareRoute()" v-if="!(isOwner || isDriver)" class="no-print" icon="share" />
        <AppButton v-if="(isOwner || isDriver) && liveState?.started" @click="prev()" icon="undo" v-tooltip="{ text: 'Fortryd ' + (liveState.driving ? 'afgang' : 'ankomst'), pos: 'right'}"></AppButton>
        <AppDropdown v-if="isOwner || isDriver" @click="minimizePlaces = false">
          <AppButton @click="resetLive()" :disabled="!liveState?.started" icon="loop">{{ $t('live.reset_live') }}</AppButton>
          <AppButton @click="prev()" :disabled="!liveState?.started" icon="undo" >{{ 'Fortryd ' + (liveState.driving ? 'afgang' : 'ankomst') }}</AppButton>
          <AppButton @click="shareRoute()" icon="share">{{ $t('route.share') }}</AppButton>
          <AppButton v-if="isOwner" @click="assignDriver()" icon="person_add">{{ $t('live.invite_driver') }}</AppButton>
          <AppButton v-if="isOwner" @click="endLive()" icon="do_not_disturb_on" class="color-error">{{ $t('live.end_live') }}</AppButton>
        </AppDropdown>
      </div>

      <LiveSummary v-if="!liveState.finnished" :route="route" :liveState="liveState" :controls="isOwner || isDriver" />
      <div class="card card-small" style="margin-bottom:1rem" v-else>
        <img src="@/assets/img/live_finished.svg" />
        <h2 class="text-c">Tak for turen!</h2>
        <div v-if="isOwner || isDriver" class="buttons flex flex-c" >
          <AppButton @click="resetLive()" icon="loop" />
          <AppButton v-if="isOwner" @click="endLive()" color="primary" class="fill-x flex-c">Afslut Live Mode</AppButton>
        </div>
      </div>
      
      <h3 style="margin-bottom: .5rem">{{ liveState.finnished ? 'Kørselstider' : 'Forventede tider' }}</h3>
    </template>

    <RoutePlaces :route="route" :places="liveState.places" :liveState="liveState" style="margin-bottom: 1rem;" />
  </FlexibleContent>
</template>

<script lang="ts">
import { defineComponent, ref, onUnmounted, computed, PropType, onMounted } from 'vue'
import { useRouter } from 'vue-router'

import AppDropdown from '@/components/atoms/AppDropdown.vue'
import FlexibleContent from '@/components/layout/FlexibleContent.vue'

import RoutePlaces from '@/components/route/RoutePlaces.vue'
import LiveSummary from '@/components/live/LiveSummary.vue'


import { store } from '@/store'
import { prevPlace, validateDriverSecret } from '@/api/tripply/live'
import { Route, RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  name: 'Route',
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    liveState: {
      type: Object as PropType<RouteLiveState>,
      required: true
    }
  },
  components: { AppDropdown, FlexibleContent, RoutePlaces, LiveSummary },
  setup(props) {
    const router = useRouter()
    const routeId = router.currentRoute.value.params.id as string
    const driverSecret = router.currentRoute.value.query.d    

    onMounted(() => {
      store.live.initialize(routeId)      
    })

    const minimizePlaces = ref(false)

    const user = store.user.get(state => state.user)
    const isOwner = computed(() => store.user.isOwner(routeId))    
    const isDriver = computed(() => driverSecret && validateDriverSecret(routeId, driverSecret as string))

    function endLive() {
      store.route.endLive(routeId)
    }

    function resetLive() {
      store.live.resetLive(routeId)
    }

    function assignDriver() {
      store.modal.showModal('AssignDriver', {route: props.route})
    }

    function prev() {
      prevPlace(routeId)
    }
    function shareRoute() {
      store.route.share(props.route.id)
    }

    onUnmounted(() => {
      store.live.terminate(routeId)
    })

    return { store, user, isOwner, isDriver, prev, routeId, assignDriver, endLive, resetLive, shareRoute, minimizePlaces }
  },
})
</script>

<style lang="scss" scoped>
#route-live-tag {
  margin-right: .5rem;
}
</style>